// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shared-info {
  max-width: 960px;
  margin: 0 auto;
  padding: 1rem 1.25rem 2rem;
}

.shared-info-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin-bottom: 1.25rem;
  padding: 0.75rem;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
}

.shared-info-toolbar-left {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1.25rem;
}

.shared-info-toolbar-right {
  margin-left: auto;
}

.shared-info-toolbar label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #4b5563;
  cursor: pointer;
}

.shared-info-toolbar-field {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: default;
}

.shared-info-toolbar-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  white-space: nowrap;
}

.shared-info-toolbar-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  background: #ffffff;
  color: #1a1a1a;
  cursor: pointer;
  min-width: 160px;
  transition: border-color 0.2s;
}

.shared-info-toolbar-select:hover {
  border-color: #9ca3af;
}

.shared-info-toolbar-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.shared-info-toolbar-add {
  white-space: nowrap;
}

.shared-info-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.shared-info-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  padding: 1rem 1.15rem;
  border-left: 4px solid transparent;
}

.shared-info-card.unseen {
  border-left-color: #3b82f6;
  background: linear-gradient(to right, rgba(59, 130, 246, 0.06), #fff 40%);
}

.shared-info-card.pinned {
  border-left-color: #d97706;
}

.shared-info-card.archived {
  opacity: 0.88;
  background: #f9fafb;
}

.shared-info-card-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.shared-info-card-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #111827;
}

.shared-info-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  align-items: center;
}

.shared-info-badge {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 0.2rem 0.45rem;
  border-radius: 4px;
  background: #e5e7eb;
  color: #374151;
}

.shared-info-badge.pinned {
  background: #fef3c7;
  color: #92400e;
}

.shared-info-badge.new {
  background: #dbeafe;
  color: #1e40af;
}

.shared-info-badge.archived {
  background: #f3f4f6;
  color: #6b7280;
}

.shared-info-meta {
  font-size: 0.8rem;
  color: #6b7280;
  margin-bottom: 0.65rem;
}

.shared-info-desc {
  font-size: 0.9rem;
  color: #374151;
  line-height: 1.5;
  margin: 0 0 0.75rem;
}

.shared-info-desc-line {
  margin: 0 0 0.35rem;
}

.shared-info-desc-line:last-child {
  margin-bottom: 0;
}

.shared-info-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #2563eb;
  text-decoration: none;
  word-break: break-all;
}

.shared-info-link:hover {
  text-decoration: underline;
}

.shared-info-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.85rem;
  padding-top: 0.75rem;
  border-top: 1px solid #f3f4f6;
}

.shared-info-actions label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.875rem;
  cursor: pointer;
  color: #374151;
}

.shared-info-btn {
  padding: 0.4rem 0.75rem;
  font-size: 0.8125rem;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.shared-info-btn:hover {
  border-color: #9ca3af;
  background: #f9fafb;
}

.shared-info-btn-danger {
  border-color: #fecaca;
  color: #b91c1c;
}

.shared-info-btn-danger:hover {
  background: #fef2f2;
}

.shared-info-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.45);
}

.shared-info-modal {
  width: 100%;
  max-width: 520px;
  max-height: min(90vh, 640px);
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: 1px solid #e5e7eb;
}

.shared-info-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f3f4f6;
  flex-shrink: 0;
}

.shared-info-modal-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: #111827;
}

.shared-info-modal-close {
  margin: 0;
  padding: 0.15rem 0.5rem;
  border: none;
  background: transparent;
  font-size: 1.5rem;
  line-height: 1;
  color: #6b7280;
  cursor: pointer;
  border-radius: 4px;
}

.shared-info-modal-close:hover {
  color: #111827;
  background: #f3f4f6;
}

.shared-info-modal-body {
  padding: 1rem;
  overflow-y: auto;
}

.shared-info-form-grid {
  display: grid;
  gap: 0.75rem;
}

@media (min-width: 640px) {
  .shared-info-form-grid {
    grid-template-columns: 1fr 1fr;
  }
  .shared-info-form-grid .full-width {
    grid-column: 1 / -1;
  }
}

.shared-info-form-grid label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #4b5563;
}

.shared-info-input,
.shared-info-modal-body select,
.shared-info-modal-body textarea {
  padding: 0.5rem 0.65rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  font-family: inherit;
  color: #1a1a1a;
}

.shared-info-modal-body textarea {
  min-height: 88px;
  resize: vertical;
}

.shared-info-form-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.shared-info-form-actions .shared-info-btn.primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.shared-info-form-actions .shared-info-btn.primary:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
}

.shared-info-error {
  color: #b91c1c;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.shared-info-loading {
  padding: 2rem;
  text-align: center;
  color: #6b7280;
}

.shared-info-empty {
  padding: 2rem;
  text-align: center;
  color: #6b7280;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px dashed #d1d5db;
}

.doc-nav-badge {
  display: inline-block;
  margin-left: 0.35rem;
  min-width: 1.1rem;
  padding: 0.05rem 0.35rem;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1.2;
  vertical-align: middle;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
}

@media (max-width: 520px) {
  .shared-info-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .shared-info-toolbar-right {
    margin-left: 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}

.header-doc-badge {
  display: inline-block;
  margin-left: 0.35rem;
  min-width: 1.15rem;
  padding: 0.08rem 0.4rem;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1.2;
  vertical-align: super;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/SharedInfo.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,yEAAyE;AAC3E;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".shared-info {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 1rem 1.25rem 2rem;\n}\n\n.shared-info-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n  margin-bottom: 1.25rem;\n  padding: 0.75rem;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n}\n\n.shared-info-toolbar-left {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem 1.25rem;\n}\n\n.shared-info-toolbar-right {\n  margin-left: auto;\n}\n\n.shared-info-toolbar label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n.shared-info-toolbar-field {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: default;\n}\n\n.shared-info-toolbar-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4b5563;\n  white-space: nowrap;\n}\n\n.shared-info-toolbar-select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  background: #ffffff;\n  color: #1a1a1a;\n  cursor: pointer;\n  min-width: 160px;\n  transition: border-color 0.2s;\n}\n\n.shared-info-toolbar-select:hover {\n  border-color: #9ca3af;\n}\n\n.shared-info-toolbar-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.shared-info-toolbar-add {\n  white-space: nowrap;\n}\n\n.shared-info-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.shared-info-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  padding: 1rem 1.15rem;\n  border-left: 4px solid transparent;\n}\n\n.shared-info-card.unseen {\n  border-left-color: #3b82f6;\n  background: linear-gradient(to right, rgba(59, 130, 246, 0.06), #fff 40%);\n}\n\n.shared-info-card.pinned {\n  border-left-color: #d97706;\n}\n\n.shared-info-card.archived {\n  opacity: 0.88;\n  background: #f9fafb;\n}\n\n.shared-info-card-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.shared-info-card-title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.shared-info-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  align-items: center;\n}\n\n.shared-info-badge {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  padding: 0.2rem 0.45rem;\n  border-radius: 4px;\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.shared-info-badge.pinned {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.shared-info-badge.new {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.shared-info-badge.archived {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n.shared-info-meta {\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin-bottom: 0.65rem;\n}\n\n.shared-info-desc {\n  font-size: 0.9rem;\n  color: #374151;\n  line-height: 1.5;\n  margin: 0 0 0.75rem;\n}\n\n.shared-info-desc-line {\n  margin: 0 0 0.35rem;\n}\n\n.shared-info-desc-line:last-child {\n  margin-bottom: 0;\n}\n\n.shared-info-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #2563eb;\n  text-decoration: none;\n  word-break: break-all;\n}\n\n.shared-info-link:hover {\n  text-decoration: underline;\n}\n\n.shared-info-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n  margin-top: 0.85rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid #f3f4f6;\n}\n\n.shared-info-actions label {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n  color: #374151;\n}\n\n.shared-info-btn {\n  padding: 0.4rem 0.75rem;\n  font-size: 0.8125rem;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #374151;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.shared-info-btn:hover {\n  border-color: #9ca3af;\n  background: #f9fafb;\n}\n\n.shared-info-btn-danger {\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.shared-info-btn-danger:hover {\n  background: #fef2f2;\n}\n\n.shared-info-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.45);\n}\n\n.shared-info-modal {\n  width: 100%;\n  max-width: 520px;\n  max-height: min(90vh, 640px);\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  border: 1px solid #e5e7eb;\n}\n\n.shared-info-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f3f4f6;\n  flex-shrink: 0;\n}\n\n.shared-info-modal-title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.shared-info-modal-close {\n  margin: 0;\n  padding: 0.15rem 0.5rem;\n  border: none;\n  background: transparent;\n  font-size: 1.5rem;\n  line-height: 1;\n  color: #6b7280;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.shared-info-modal-close:hover {\n  color: #111827;\n  background: #f3f4f6;\n}\n\n.shared-info-modal-body {\n  padding: 1rem;\n  overflow-y: auto;\n}\n\n.shared-info-form-grid {\n  display: grid;\n  gap: 0.75rem;\n}\n\n@media (min-width: 640px) {\n  .shared-info-form-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n  .shared-info-form-grid .full-width {\n    grid-column: 1 / -1;\n  }\n}\n\n.shared-info-form-grid label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #4b5563;\n}\n\n.shared-info-input,\n.shared-info-modal-body select,\n.shared-info-modal-body textarea {\n  padding: 0.5rem 0.65rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-family: inherit;\n  color: #1a1a1a;\n}\n\n.shared-info-modal-body textarea {\n  min-height: 88px;\n  resize: vertical;\n}\n\n.shared-info-form-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n}\n\n.shared-info-form-actions .shared-info-btn.primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.shared-info-form-actions .shared-info-btn.primary:hover {\n  background: #1d4ed8;\n  border-color: #1d4ed8;\n}\n\n.shared-info-error {\n  color: #b91c1c;\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n\n.shared-info-loading {\n  padding: 2rem;\n  text-align: center;\n  color: #6b7280;\n}\n\n.shared-info-empty {\n  padding: 2rem;\n  text-align: center;\n  color: #6b7280;\n  background: #f9fafb;\n  border-radius: 8px;\n  border: 1px dashed #d1d5db;\n}\n\n.doc-nav-badge {\n  display: inline-block;\n  margin-left: 0.35rem;\n  min-width: 1.1rem;\n  padding: 0.05rem 0.35rem;\n  font-size: 0.65rem;\n  font-weight: 700;\n  line-height: 1.2;\n  vertical-align: middle;\n  border-radius: 999px;\n  background: #ef4444;\n  color: #fff;\n}\n\n@media (max-width: 520px) {\n  .shared-info-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .shared-info-toolbar-right {\n    margin-left: 0;\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.header-doc-badge {\n  display: inline-block;\n  margin-left: 0.35rem;\n  min-width: 1.15rem;\n  padding: 0.08rem 0.4rem;\n  font-size: 0.65rem;\n  font-weight: 700;\n  line-height: 1.2;\n  vertical-align: super;\n  border-radius: 999px;\n  background: #ef4444;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
